<template>
  <div class="undo-button-container" v-if="game.state.screen === 'playing' && game.state.activePlayMode !== 'replay'">
    <ion-button @click="undoLastMove" fill="clear">
      <ion-icon :icon="arrowUndoOutline" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { IonButton, IonIcon } from '@ionic/vue';
import { arrowUndoOutline } from 'ionicons/icons';
import { GameEvents } from '../lib/GameEvents';

const game = inject('game');

const undoLastMove = () => game.dispatch(GameEvents.UNDO_LAST_MOVE);
</script>

<style scoped>
.undo-button-container {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(calc(-50% - 150px)); /* Position to the left of ActionToolbar with 10px gap */
  display: flex;
  background-color: var(--hw-bg-overlay);
  border: 1px solid var(--hw-border);
  padding: 10px;
  border-radius: var(--hw-radius);
  z-index: 1000;
}

.undo-button-container ion-button {
  font-size: 1.5em;
  min-width: 50px;
  min-height: 50px;
  color: var(--hw-text);
}
</style>
